<div class="drag-selector" #dragSelector></div>